import { ResignationRequestFormResponse } from '@Types/api/form';
import { OptionNum } from '@Components/types/options';
import { parseDateTime } from '@Utils/transformDateTime';
import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';

const fieldSource = (
  data: ResignationRequestFormResponse,
  reasonOptions: OptionNum[],
  settlementAmount: string
): Array<{ label: string; value: string | number | boolean }> => {
  const { statusId, resDate, lastWrkngDate, letterContent, reason } = data;

  const matchedReason = reasonOptions.find(
    (reasonItem) => reasonItem.value === reason
  )?.label;

  const source = {
    Status: statusId,
    'Resignation Date': parseDateTime(resDate),
    'Approx settlement amount': settlementAmount || EMPTY_FIELD_PLACEHOLDER,
    'Last working date': parseDateTime(lastWrkngDate),
    'Letter of content': letterContent || EMPTY_FIELD_PLACEHOLDER,
    Reason: matchedReason || EMPTY_FIELD_PLACEHOLDER,
  };

  return Object.entries(source).map((item) => ({
    label: item[0],
    value: item[1],
  }));
};

export default fieldSource;
